/* Change this file to get your personal Porfolio */

// Website related settings
const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Anis Belhadj's Portfolio",
  description:
    "Final-year computer engineering student passionate about Data, DevOps, and web & mobile development. Seeking opportunities to apply skills in software development, AI, and cloud technologies.",
  og: {
    title: "Anis Belhadj Portfolio",
    type: "website",
    url: "http://anisbelhadj.com/",
  },
};

//Home Page
const greeting = {
  title: "Anis Belhadj",
  logo_name: "AnisBelhadj",
  nickname: "anis_belhadj",
  subTitle:
    "Final-year computer engineering student passionate about Data, DevOps, and web & mobile development. Seeking opportunities to apply skills in software development, AI, and cloud technologies.",
  resumeLink:
    "Anis_Belhadj_CV_2025.pdf",
  portfolio_repository: "https://github.com/B3lhadj",
  githubProfile: "https://github.com/B3lhadj",
};

const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/B3lhadj",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/anis-belhadj/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:anisbelhadj.contact@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

const skills = {
  data: [
    {
      title: "Data Science & AI",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing machine learning models for disease detection and cryptocurrency price prediction",
        "⚡ Experience with Computer Vision projects including CNN models for plant disease classification",
        "⚡ Data analysis and visualization using Pandas, NumPy, and Matplotlib",
      ],
      softwareSkills: [
        {
          skillName: "Tensorflow",
          fontAwesomeClassname: "logos-tensorflow",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Keras",
          fontAwesomeClassname: "simple-icons:keras",
          style: {
            backgroundColor: "white",
            color: "#D00000",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#150458",
          },
        },
        {
          skillName: "Scikit-learn",
          fontAwesomeClassname: "simple-icons:scikitlearn",
          style: {
            backgroundColor: "transparent",
            color: "#F7931E",
          },
        },
        {
          skillName: "Streamlit",
          fontAwesomeClassname: "simple-icons:streamlit",
          style: {
            backgroundColor: "transparent",
            color: "#FF4B4B",
          },
        },
      ],
    },
    {
      title: "Full Stack Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Building responsive web applications using React.js, HTML5, CSS3, and JavaScript",
        "⚡ Developing mobile applications using Flutter for cross-platform development",
        "⚡ Creating backend APIs using Node.js, Express.js, and Flask",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Bootstrap",
          fontAwesomeClassname: "simple-icons:bootstrap",
          style: {
            color: "#7952B3",
          },
        },
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "devicon-plain:nodejs-wordmark",
          style: {
            color: "#339933",
          },
        },
        {
          skillName: "ExpressJS",
          fontAwesomeClassname: "simple-icons:express",
          style: {
            color: "#000000",
          },
        },
        {
          skillName: "PHP",
          fontAwesomeClassname: "simple-icons:php",
          style: {
            color: "#777BB4",
          },
        },
        {
          skillName: "Flutter",
          fontAwesomeClassname: "simple-icons:flutter",
          style: {
            color: "#02569B",
          },
        },
      ],
    },
    {
      title: "Programming Languages",
      fileName: "ProgrammingImg",
      skills: [
        "⚡ Proficient in multiple programming languages for various development needs",
        "⚡ Experience with object-oriented programming and software architecture",
        "⚡ Cross-platform development using modern programming paradigms",
      ],
      softwareSkills: [
        {
          skillName: "Java",
          fontAwesomeClassname: "simple-icons:java",
          style: {
            color: "#ED8B00",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "C",
          fontAwesomeClassname: "simple-icons:c",
          style: {
            color: "#A8B9CC",
          },
        },
        {
          skillName: "C#",
          fontAwesomeClassname: "simple-icons:csharp",
          style: {
            color: "#239120",
          },
        },
        {
          skillName: "Perl",
          fontAwesomeClassname: "simple-icons:perl",
          style: {
            color: "#39457E",
          },
        },
      ],
    },
    {
      title: "Databases & Tools",
      fileName: "DatabaseImg",
      skills: [
        "⚡ Experience with both SQL and NoSQL database management",
        "⚡ Version control and code management using Git and GitHub",
        "⚡ Development environments and integrated development tools",
      ],
      softwareSkills: [
        {
          skillName: "MySQL",
          fontAwesomeClassname: "simple-icons:mysql",
          style: {
            color: "#4479A1",
          },
        },
        {
          skillName: "MongoDB",
          fontAwesomeClassname: "simple-icons:mongodb",
          style: {
            color: "#47A248",
          },
        },
        {
          skillName: "Git",
          fontAwesomeClassname: "simple-icons:git",
          style: {
            color: "#F05032",
          },
        },
        {
          skillName: "GitHub",
          fontAwesomeClassname: "simple-icons:github",
          style: {
            color: "#181717",
          },
        },
        {
          skillName: "Visual Studio",
          fontAwesomeClassname: "simple-icons:visualstudio",
          style: {
            color: "#5C2D91",
          },
        },
        {
          skillName: "Android Studio",
          fontAwesomeClassname: "simple-icons:androidstudio",
          style: {
            color: "#3DDC84",
          },
        },
      ],
    },
    {
      title: "UI/UX Design",
      fileName: "DesignImg",
      skills: [
        "⚡ Designing highly attractive user interface for mobile and web applications",
        "⚡ Customizing logo designs and building logos from scratch",
        "⚡ Creating the flow of application functionalities to optimize user experience",
      ],
      softwareSkills: [
        {
          skillName: "Adobe XD",
          fontAwesomeClassname: "simple-icons:adobexd",
          style: {
            color: "#FF2BC2",
          },
        },
        {
          skillName: "Figma",
          fontAwesomeClassname: "simple-icons:figma",
          style: {
            color: "#F24E1E",
          },
        },
        {
          skillName: "Adobe Illustrator",
          fontAwesomeClassname: "simple-icons:adobeillustrator",
          style: {
            color: "#FF7C00",
          },
        },
        {
          skillName: "Inkscape",
          fontAwesomeClassname: "simple-icons:inkscape",
          style: {
            color: "#000000",
          },
        },
      ],
    },
  ],
};

// Education Page
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "GitHub",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "#181717",
      },
      profileLink: "https://github.com/B3lhadj",
    },
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077B5",
      },
      profileLink: "https://www.linkedin.com/in/anis-belhadj/",
    },
    {
      siteName: "Kaggle",
      iconifyClassname: "simple-icons:kaggle",
      style: {
        color: "#20BEFF",
      },
      profileLink: "https://www.kaggle.com/anisbelhadj",
    },
  ],
};

const degrees = {
  degrees: [
    {
      title: "École Pluridisciplinaire Internationale - EPI Sousse",
      subtitle: "National Engineering Diploma - Software Engineering",
      logo_path: "EpiLogo.png",
      alt_name: "EPI Sousse",
      duration: "In Progress",
      descriptions: [
        "⚡ Final-year computer engineering student specializing in software engineering",
        "⚡ Focused on Data Science, DevOps, and web & mobile development technologies",
        "⚡ Seeking summer internship opportunities to apply skills in software development, AI, and cloud technologies",
      ],
      website_link: "https://www.epi.tn/",
    },
    {
      title: "Higher Institute of Technological Studies of Mahdia (ISET Mahdia)",
      subtitle: "Bachelor's in Electrical Engineering - Automation & Industrial Computing",
      logo_path: "IsetLog.jpg",
      alt_name: "ISET Mahdia",
      duration: "2020 - 2023",
      descriptions: [
        "⚡ Completed Bachelor's degree in Electrical Engineering with focus on Automation & Industrial Computing",
        "⚡ Gained foundational knowledge in industrial systems, automation, and computing technologies",
        "⚡ Developed skills in PLC programming and industrial network design",
      ],
      website_link: "https://www.isetmd.rnu.tn/",
    },
    {
      title: "Lycée Ibn Sina Mahdia",
      subtitle: "High School Diploma - Technical Sciences",
      logo_path: "education.svg",
      alt_name: "Lycée Ibn Sina",
      duration: "2020",
      descriptions: [
        "⚡ Completed high school education with focus on Technical Sciences",
        "⚡ Built strong foundation in mathematics, physics, and technical subjects",
        "⚡ Prepared for higher education in engineering and technology fields",
      ],
      website_link: "https://www.education.gov.tn/",
    },
  ],
};

const certifications = {
  certifications: [
    {
      title: "AWS Academy Cloud Foundations",
      subtitle: "- AWS",
      logo_path: "gcp_logo.png",
      certificate_link: "#",
      alt_name: "Amazon Web Services",
      color_code: "#FF990099",
    },
    {
      title: "Introduction to Programming using Python",
      subtitle: "- Microsoft",
      logo_path: "microsoft_logo.png",
      certificate_link: "#",
      alt_name: "Microsoft",
      color_code: "#D83B0199",
    },
    {
      title: "Python for Data Science, AI & Development",
      subtitle: "- IBM",
      logo_path: "ibm_logo.png",
      certificate_link: "#",
      alt_name: "IBM",
      color_code: "#1F70C199",
    },
    {
      title: "Cisco CCNA 1 Networking Fundamentals",
      subtitle: "- Cisco",
      logo_path: "microsoft_logo.png",
      certificate_link: "#",
      alt_name: "Cisco",
      color_code: "#1BA0D799",
    },
  ],
};

// Experience Page
const experience = {
  title: "Experience",
  subtitle: "Work, Internship and Projects",
  description:
    "I have gained experience through various internships and projects in software development, AI, and mobile development. My experience includes working with startups and established companies, focusing on full-stack development, machine learning, and cloud technologies.",
  header_image_path: "experience.svg",
  sections: [
    {
      title: "Intership",
      work: true,
      experiences: [
        {
          title: ".NET Developer Intern - Security Architecture Application",
          company: "Insomia Tunisie",
          company_url: "#",
          logo_path: "microsoft_logo.png",
          duration: "July 2025 - August 2025",
          location: "Tunis, Tunisia",
          description:
            "Developed a secure web application to evaluate Microsoft 365 and Azure security levels. Integrated Microsoft Graph API and Azure SDK to audit cloud configurations. Built interface using ASP.NET Core (.NET 7) with Razor Pages/Blazor. Implemented dashboard displaying Secure Score, alerts, and vulnerability details. Automated security checks using PowerShell and managed SQL Server/Azure SQL storage.",
          color: "#0078D4",
        },
        {
          title: "AI & Mobile Developer - Tomato Disease Detection Project",
          company: "Personal Project",
          company_url: "#",
          logo_path: "data_science.svg",
          duration: "September 2024 - December 2024",
          location: "EPI Sousse, Tunisia",
          description:
            "Developed a Flutter mobile app for tomato disease detection. Trained a CNN model using TensorFlow/Keras for leaf disease classification. Created Flask backend API for real-time predictions. Designed user interface showing disease name, confidence score, and recommendations. Targeted deployment for Tunisian agricultural market with bilingual support (Arabic/French).",
          color: "#02569B",
        },
        {
          title: "Web Development Intern - RentCar Marketplace",
          company: "Quaratech",
          company_url: "#",
          logo_path: "fullstack.svg",
          duration: "June 2024 - August 2024",
          location: "Mahdia, Tunisia",
          description:
            "Built a car rental platform with three user roles: admin, renter, client. Developed frontend with React.js/Redux and integrated Stripe payments. Created backend with Node.js/Express and MongoDB for user, vehicle, and booking management. Implemented subscription system for renters with free trials, post limits, and email notifications. Built dashboard to manage vehicles, bookings, and revenue.",
          color: "#61DAFB",
        },
        {
          title: "Mobile Developer - Graduation Internship",
          company: "ASM Sfax",
          company_url: "#",
          logo_path: "developerActivity.svg",
          duration: "January 2023 - June 2023",
          location: "Sfax, Tunisia",
          description:
            "Developed mobile app for remote supervision and control of PLCs via MQTT. Designed Flutter interface for monitoring digital and analog signals. Integrated Siemens S7-1200 PLCs and ESP8266 microcontrollers. Conducted performance and reliability testing for industrial networks.",
          color: "#3DDC84",
        },
      ],
    },
    
  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects showcase my expertise in full-stack development, AI/ML, mobile development, and cloud technologies. I focus on creating practical solutions that solve real-world problems.",
  avatar_image_path: "projects_image.svg",
};

const publicationsHeader = {
  title: "Featured Projects",
  description: "Key projects from my academic work and internships showcasing my technical skills.",
  avatar_image_path: "projects_image.svg",
};

const publications = {
  data: [
   
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "animated_ashutosh.jpg",
    description:
      "I am available for opportunities in software development, AI, and cloud technologies. You can reach me through email or LinkedIn. I can help you with full-stack development, machine learning, mobile development, and cloud technologies.",
  },
  blogSection: {
    title: "Get in Touch",
    subtitle:
      "I am passionate about software development, AI, and emerging technologies. I enjoy building projects that solve real-world problems and am always eager to collaborate on innovative solutions. Feel free to reach out to discuss opportunities, projects, or technology ideas.",
    link: "https://www.linkedin.com/in/anis-belhadj/",
    avatar_image_path: "blogs_image.svg",
  },
  addressSection: {
    title: "Address",
    subtitle: "Mahdia, Tunisia",
    locality: "Mahdia",
    country: "Tunisia",
    region: "Mahdia",
    postalCode: "5100",
    streetAddress: "Mahdia",
    avatar_image_path: "address_image.svg",
    location_map_link: "https://maps.google.com/?q=Mahdia,Tunisia",
  },
  phoneSection: {
    title: "Email",
    subtitle: "anisbelhadj.contact@gmail.com",
  },
};

const contactInfo = {
  title: "Contact Me",
  subtitle: "I am available for opportunities in software development, AI, and cloud technologies",
  number: "+216 ",
  email_address: "anisbelhadj.contact@gmail.com"
};

const openSource = {
  githubUserName: "B3lhadj",
  githubConvertedToken: "YourGitHubTokenHere",
};

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  degrees,
  certifications,
  experience,
  projectsHeader,
  publicationsHeader,
  publications,
  contactPageData,
  contactInfo,
  openSource,
};

